"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCreator = (reduxContext, requests, onRedirect, errorHandler, onSuccess, suppressReject = false) => {
    /**
     * Type creator
     */
    const typeCreator = (action) => ({
        TYPE: action,
        request: `@${reduxContext}:${action}_REQUEST`,
        success: `@${reduxContext}:${action}_SUCCESS`,
        fail: `@${reduxContext}:${action}_FAIL`,
    });
    /**
     * Handle Request error
     */
    const handleError = (dispatch, reject, type) => (e) => {
        dispatch({ type });
        if (errorHandler)
            errorHandler(e, dispatch);
        if (!suppressReject)
            return reject(e);
    };
    /**
     * Handle Request error
     */
    const handleRedirectSuccess = (dispatch, resolve, type, redirect, options) => (data) => {
        dispatch({ type: type.success, payload: data });
        if (onSuccess)
            onSuccess(type.TYPE, dispatch, data);
        if (onRedirect) {
            if (options && options.redirect)
                dispatch(onRedirect(options.redirect.replace(':id', `${data.id}`)));
            else if (redirect)
                dispatch(onRedirect(redirect.replace(':id', `${data.id}`)));
        }
        return resolve(data);
    };
    /**
     * Handle Request error
     */
    const handleDeleteRedirectSuccess = (dispatch, resolve, type, redirect, options) => (data) => {
        dispatch({ type: type.success, payload: data });
        if (onSuccess)
            onSuccess(type.TYPE, dispatch, data);
        if (onRedirect) {
            if (options && options.redirect)
                dispatch(onRedirect(options.redirect.replace(':id', `${data.id}`)));
            else if (redirect)
                dispatch(onRedirect(redirect.replace(':id', `${data.id}`)));
        }
        return resolve(data);
    };
    /**
     * Count action
     */
    const countRequest = (dispatch, filter) => {
        const tc = typeCreator('COUNT');
        dispatch({ type: tc.request });
        return new Promise((resolve, reject) => {
            requests
                .count(filter)
                .then((data) => {
                dispatch({ type: tc.success, payload: data });
                resolve();
            })
                .catch(handleError(dispatch, reject, tc.fail));
        });
    };
    return {
        /**
         * Create Action
         */
        getCreateAction: (redirect, middleware, handleMiddlewarePreLoading = false) => (body, options) => (dispatch) => {
            const tc = typeCreator('CREATE');
            if (!handleMiddlewarePreLoading)
                dispatch({ type: tc.request });
            return new Promise((resolve, reject) => {
                let mid = (b, _) => Promise.resolve(b);
                if (middleware)
                    mid = middleware;
                mid(body, dispatch)
                    .then((b) => {
                    if (handleMiddlewarePreLoading)
                        dispatch({ type: tc.request });
                    return requests.create(b);
                })
                    .then(handleRedirectSuccess(dispatch, resolve, tc, redirect, options))
                    .catch(handleError(dispatch, reject, tc.fail));
            });
        },
        /**
         * Update Action
         */
        getUpdateAction: (redirect, middleware, handleMiddlewarePreLoading = false) => (id, body, options) => (dispatch) => {
            const tc = typeCreator('UPDATE');
            if (!handleMiddlewarePreLoading)
                dispatch({ type: tc.request });
            return new Promise((resolve, reject) => {
                let mid = (b, _) => Promise.resolve(b);
                if (middleware)
                    mid = middleware;
                mid(body, dispatch)
                    .then((b) => {
                    if (handleMiddlewarePreLoading)
                        dispatch({ type: tc.request });
                    return requests.update(id, b);
                })
                    .then(handleRedirectSuccess(dispatch, resolve, tc, redirect, options))
                    .catch(handleError(dispatch, reject, tc.fail));
            });
        },
        /**
         * Delete Action
         */
        getDeleteAction: (redirect, question) => (id, options) => (dispatch) => {
            const tc = typeCreator('DELETE');
            dispatch({ type: tc.request });
            if (question) {
                if (!confirm(question))
                    return Promise.reject();
            }
            return new Promise((resolve, reject) => {
                requests
                    .delete(id)
                    .then(handleDeleteRedirectSuccess(dispatch, resolve, tc, redirect, options))
                    .catch(handleError(dispatch, reject, tc.fail));
            });
        },
        /**
         * Fetch Action
         */
        getFindByIdAction: () => (id, filter) => (dispatch) => {
            const tc = typeCreator('FETCH');
            dispatch({ type: tc.request });
            return new Promise((resolve, reject) => {
                requests
                    .getById(id, filter)
                    .then(handleRedirectSuccess(dispatch, resolve, tc))
                    .catch(handleError(dispatch, reject, tc.fail));
            });
        },
        /**
         * List And Count Action
         */
        getFindAndCountAction: () => (filter) => (dispatch) => {
            const tl = typeCreator('LIST');
            dispatch({ type: tl.request });
            countRequest(dispatch, filter);
            return new Promise((resolve, reject) => {
                requests
                    .getAll(filter)
                    .then((data) => {
                    dispatch({ type: tl.success, payload: data });
                    resolve(data);
                })
                    .catch(handleError(dispatch, reject, tl.fail));
            });
        },
        /**
         * Clean
         */
        getCleanAction: () => () => ({
            type: `@${reduxContext}:CLEAN`,
        }),
    };
};
//# sourceMappingURL=ActionCreator.js.map